import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { cloneDeep, isEmpty, orderBy as lodashOrder } from 'lodash';

import { Grid, getSelectedState, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess, orderBy, filterBy } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';

import * as AttributeManagementActions from '../../../actions/attributeManagementActions';

import * as classes from './AssignmentTable.module.css';

const idGetter = getter('id');

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const initialDataState = {
    filter: initialDataStateFilter,
    sort:   [],
    skip:   0
};

const AssignmentTable = ({
    columns,
    data,
    entities,
    selectedEntity,
    setAMSelectedState,
    workbookModeEnabled,
    ...props
}) => {
    const [dataState, setDataState] = useState(initialDataState);
    const [tableSelectState, setTableSelectState] = useState({});
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const init = () => {
            let payload = lodashOrder(data, ['name']);
            setTableData(payload);
        };

        if (!isEmpty(data)) init();
    }, [data]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            setDataState({...dataState, filter: initialDataStateFilter});
        }
    }, [workbookModeEnabled]);

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    const onHeaderSelectionChange = event => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = cloneDeep(tableSelectState);

        const filteredData = orderBy(filterBy(tableData, dataState.filter), dataState.sort);
        filteredData.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });

        const selectedEntityIds = Object.keys(newSelectedState).filter(k => newSelectedState[k] === true);
        const selectedEntites = entities.filter(({ id }) => selectedEntityIds.includes(id));

        setAMSelectedState(selectedEntites);
        setTableSelectState(newSelectedState);
    };


    const onSelectionChange = event => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: tableSelectState,
            dataItemKey:   'id',
        });

        const selectedEntityIds = Object.keys(newSelectedState).filter(k => newSelectedState[k] === true);
        const selectedEntites = entities.filter(({ id }) => selectedEntityIds.includes(id));

        setAMSelectedState(selectedEntites);
        setTableSelectState(newSelectedState);
    };

    return (
        <React.Fragment>
            <style>
                {
                    `
                        .k-grid-header-locked > table, .k-grid-header-wrap > table {
                            width: 100% !important;
                        }
                        .k-grid-content table, .k-grid-content-locked table {
                            width: 100% !important;
                        }
                    `
                }
            </style>
            <Grid
                sortable={{
                    mode: 'multiple'
                }}
                className={classes.KendoGrid}
                data={kendoProcess(tableData.map((item) => ({
                    ...item, 'selected': tableSelectState[idGetter(item)],
                })), dataState)}
                {...dataState}
                reorderable
                dataItemKey="id"
                selectedField="selected"
                filterable={workbookModeEnabled}
                onDataStateChange={onDataStateChange}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
            >
                <Column
                    filterable={false}
                    field="selected"
                    width={60}
                    headerSelectionValue={
                        orderBy(filterBy(tableData, dataState.filter), dataState.sort).length > 0 &&
                        orderBy(filterBy(tableData, dataState.filter), dataState.sort).findIndex((item) => !tableSelectState[idGetter(item)]) === -1
                    }
                />
                {
                    columns.map(
                        (column, index) =>
                            column.show && (
                                <Column
                                    key={index}
                                    field={column.field}
                                    title={column.title}
                                    id={column.id}
                                    cell={column.cell}
                                    width={column.isAttribute === true ? 'auto' : column.width}
                                    filter={column.filter}
                                    sortable={column.sortable}
                                    filterable={workbookModeEnabled}
                                    locked={column.locked}
                                    reorderable={column.reorderable}
                                />
                            )
                    )
                }
            </Grid>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        entities:            state.attributeManagement.entities,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = ({
    ...AttributeManagementActions
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentTable);
